var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-body",class:_vm.platformName,style:({
    overflow: _vm.isMenuOpen ? 'hidden' : ''
  }),attrs:{"id":"app"}},[_c('common-loader',{class:{
      'is-loading': _vm.isLoaderLoading
    }}),_vm._v(" "),_c('global-header'),_vm._v(" "),_c('global-navigation'),_vm._v(" "),_c('destination-menu'),_vm._v(" "),_c('cover-image'),_vm._v(" "),_c('div',{staticClass:"l-content",class:{
      'is-menu-open': _vm.isMenuOpen
    }},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMenuOpen),expression:"isMenuOpen"}],staticClass:"l-content__hitArea",on:{"click":function($event){$event.preventDefault();_vm.onClickContent($event)}}}),_vm._v(" "),_c('main',{staticClass:"l-main",class:{
        'is-loading': _vm.isLoading
      }},[_c('router-view',{key:_vm.$route.path})],1),_vm._v(" "),_c('global-footer',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInitialized),expression:"isInitialized"}],class:{
        'is-loading': _vm.isLoading
      }})],1),_vm._v(" "),_c('cominca-pagetop',{attrs:{"is-visible":_vm.isPageTopVisible}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b396c2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 